import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { primaryColor, backgroundGrey } from '~theme';

const Dropdown = ({
  options,
  onChange,
  value,
  header,
  className,
  secondary,
  disabled,
}) => {
  const foregroundColor = secondary ? 'white' : primaryColor;
  let backgroundColor = backgroundGrey;
  if (header) backgroundColor = 'white';
  if (secondary) backgroundColor = primaryColor;

  return (
    <Container className={className}>
      <Select
        header={header}
        className="form-control"
        name="status"
        value={value}
        onChange={event => onChange(event.target.value)}
        $foregroundColor={foregroundColor}
        $backgroundColor={backgroundColor}
        secondary={secondary}
        disabled={disabled}
      >
        <option value="" disabled hidden>
          Valitse...
        </option>
        {options.map(option => (
          <option key={option.key || option.label} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      {!disabled && (
        <Chevron
          header={header}
          $foregroundColor={foregroundColor}
          icon={faChevronDown}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  // margin-top: 5px;
`;

const headerHeight = 50;
const normalHeight = 40;

const Chevron = styled(FontAwesomeIcon)`
  font-size: 18px;
  color: ${props => props.$foregroundColor};
  right: 12px;
  top: ${props =>
    props.header ? headerHeight / 2 - 7 : normalHeight / 2 - 8}px;
  padding: 0;
  position: absolute;
  pointer-events: none;
`;

const Select = styled.select`
  display: block;
  font-weight: 400;
  font-size: ${props => (props.header ? '22px' : '16px')};
  color: ${props => props.$foregroundColor};
  text-align: left;
  // width: auto;
  // width: 250px;
  overflow: hidden;
  height: ${props => (props.header ? headerHeight : normalHeight)}px;
  border-radius: 3px !important;
  padding: ${props => (props.secondary ? '7px' : '10px')} 35px 10px 15px;
  /* background-color: ${props => props.backgroundColor}; */
  background: ${props => (props.secondary ? primaryColor : '#fff')};
  outline: none;
  border: ${props => (props.secondary ? '1px solid #fff' : 'none')};

  appearance: none;
  cursor: pointer;
  border-radius: 0px;
  // margin-top: 5px;

  &:active,
  &:focus {
    background: ${props => (props.secondary ? primaryColor : '#fff')};
    outline: none;
    color: ${props => props.$foregroundColor};
  }

  &::-ms-expand {
    display: none;
  }
`;

export default Dropdown;
